<template>
  <div class="langs">
    <span class="lang" :class="{'selected': lang === 'en', 'not-hovered': browser === 'ios'}" @click="setLang('en')">
      <span>En</span>
    </span>
  	<span class="lang" :class="{'selected': lang === 'ru', 'not-hovered': browser === 'ios'}" @click="setLang('ru')">
      <span>Ru</span>
    </span>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import browserDetect from '@/helpers/browserDetect';

  export default {
    name: 'langs',
    data() {
      return {
        browser: browserDetect(),
      };
    },
    computed: mapGetters({
      lang: 'lang',
    }),
    methods: {
      setLang(currentLang) {
        this.$store.commit('SET_LANG', currentLang);
      },
    },
  };
</script>

<style scoped>
  .langs {
    /*display: none;*/
    position: absolute;
    right: 25px;
    top: 25px;
    pointer-events: auto;
    z-index: -1;

    .lang {
      position: relative;
      display: inline-block;
      vertical-align: top;
      text-transform: uppercase;
      margin: 0 10px 0 0;
      letter-spacing: 0.5px;
      font-size: 14px;
      line-height: 110%;
      outline: none;

      &:last-child {
        margin-right: 0;
      }

      span {
        cursor: pointer;
        position: relative;
        display: inline-block;

        &:after {
          content: '';
          width: 0;
          height: 5px;
          background: $main-color;
          position: absolute;
          left: 0;
          bottom: -1px;
          transition: width 0.5s cubic-bezier(0.455, 0.065, 0.000, 0.990);
        }
      }

      &:not(.not-hovered):hover {
        span {
          &:after {
            width: 100%;
          }
        }
      }

      &.selected {
        span {
          &:after {
            width: 100%;
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Langs.vue?77b75332